class Password {
  title = "";
  link = "";
  username = "";
  password = "";
  option1 = "";
  option2 = "";
  option3 = "";
}
export default Password;
